import React, { useMemo } from 'react';

import { ImageResizeOptions, Image } from 'wix-ui-tpa';

import { useTranslation } from '@wix/yoshi-flow-editor';

import { messagesModel, selectSettings } from '@/features';
import { senderIsVisitor } from '@/utils/sender';
import { useAppSelector } from '@/store';

import {
  useRootProps,
  useWidgetSettings,
} from 'AiAssistantWidget/Widget/contexts';
import { iconsDict } from 'AiAssistantWidget/Settings/components';
import settingsParams from 'AiAssistantWidget/settingsParams';

import { AIAvatarIcon, AvatarIcon } from '../svg';

type AvatarProps = {
  message?: messagesModel.Message;
  memberIconClassname: string;
};

export const Avatar = ({ message, memberIconClassname }: AvatarProps) => {
  const { t } = useTranslation();
  const { avatar: memberAvatar } = useRootProps();
  const widgetSettings = useWidgetSettings();
  const avatar = useAppSelector(selectSettings.avatar);
  const notVisitorMessage = !senderIsVisitor(message?.sender);

  const assistantAvatar = useMemo(() => {
    if (avatar) {
      return (
        <Image
          width={28}
          height={28}
          aspectRatio="square"
          src={avatar}
          resize={ImageResizeOptions.cover}
        />
      );
    }
    const iconKey = widgetSettings.get(
      settingsParams.minimizedButtonIcon,
      'primary',
    );
    return iconKey ? iconsDict[iconKey] : <AIAvatarIcon />;
  }, [widgetSettings, avatar]);

  if (!notVisitorMessage) {
    return memberAvatar ? (
      <img
        className={memberIconClassname}
        src={memberAvatar}
        alt={t('app.widget.chat.userPicAltText')}
      />
    ) : (
      <AvatarIcon />
    );
  }

  return assistantAvatar;
};
